import type { TranslationKey } from "@/i18n";
import type { Locale } from "@/i18n";
import type { Unit } from "@/types";

/**
 * Numerals are kept locale-neutral by design (see spec): only unit *labels*
 * (axis/column headers) are translated, never the digits themselves.
 */
export function formatValue(value: number, unit: Unit): string {
  switch (unit) {
    case "sek_per_unit":
      return value.toFixed(4);
    case "percent":
      return `${value.toFixed(2)}%`;
    case "index_points":
      return `${value.toFixed(2)} pts`;
  }
}

export function formatDelta(delta: number, unit: Unit): string {
  if (delta === 0) return `±${formatValue(0, unit)}`;
  const sign = delta > 0 ? "+" : "-";
  return `${sign}${formatValue(Math.abs(delta), unit)}`;
}

export function unitLabelKey(unit: Unit): TranslationKey {
  switch (unit) {
    case "sek_per_unit":
      return "unit.sekPerUnit";
    case "percent":
      return "unit.percent";
    case "index_points":
      return "unit.indexPoints";
  }
}

export function currencyDisplayName(iso: string, locale: Locale): string {
  try {
    const names = new Intl.DisplayNames([locale], { type: "currency" });
    return names.of(iso) ?? iso;
  } catch {
    return iso;
  }
}
